export const headerShortcuts = [
	{
		id: 'HEADER_TOGGLE_SHORTCUTS_DRAWER',
		name: 'Open shortcuts drawer',
		group: 'General',
		initialKeys: 'alt+shift+1',
		triggersInInputs: true,
		triggersInTextareas: true,
		isDesactivatable: true,
		isOverridable: false,
	},
    {
		id: 'HEADER_HELP',
		name: 'Open help',
		group: 'General',
        initialKeys: 'alt+shift+4',
		triggersInInputs: true,
	},
	{
		id: 'HEADER_GLOBAL_NAVIGATION',
		name: 'Open Global Navigation',
		group: 'General',
		initialKeys: 'alt+shift+5',
		// isLocal: false, => TODO: working example with isLocal true and check why setting it to false does create an error
		triggersInInputs: true,
	},
    {
		id: 'HEADER_SEARCH',
		name: 'Search',
		group: 'Settings panel',
		initialKeys: 'alt+shift+2',
		// isLocal: false,
		triggersInInputs: true,
	},
    {
		id: 'HEADER_LANGUAGE',
		name: 'Language settings',
		group: 'Settings panel',
		initialKeys: 'alt+shift+3',
		// isLocal: false,
		triggersInInputs: true,
	},
];
